import React from 'react';
import {Navbar} from '../../../components';
export default () => (
  <>
    <Navbar />
    <div></div>
  </>
);
